import React from 'react';
import { useLogout, useUserContext } from '@blocs.auth';
import { PaywallLocation } from '@blocs.paywall';
import { BasicContainer } from '@minecraft.atoms';
import Nav from './Nav';
import { PageCreditsUI } from './PageCreditsUI';

export type HeaderProps = {
  hideNavigation: boolean;
  showLogoutWhenHiddenNav?: boolean;
  location?: PaywallLocation;
};

const Header = ({ hideNavigation, showLogoutWhenHiddenNav, location }: HeaderProps): JSX.Element => {
  const { myAccount } = useUserContext();
  const [logout] = useLogout(false);

  if (!myAccount && !hideNavigation) {
    // this should not happen, when running the apps live b/c this
    // should always be inside the <AuthenticatedWrapper /> which will
    // not render its children if the myAccount data isn't available
    return null;
  }

  return (
    <>
      <BasicContainer bgColor="card" w="full" borderPlacement="bottom">
        <div key="main-nav">
          <Nav
            hideNavigation={hideNavigation}
            logout={logout}
            showLogoutWhenHiddenNav={showLogoutWhenHiddenNav}
            location={location}
          />
        </div>
      </BasicContainer>
      {!hideNavigation && <PageCreditsUI />}
    </>
  );
};

export default Header;
